export default __webpack_public_path__ + "assets/images/1cfefb268087bd2d1a2a7cbb3e74131a.webp";